import { quicker } from '@unistocks/shared/animations';
import Animated, { interpolateColor, useAnimatedStyle, withSpring } from 'react-native-reanimated';
import { useItemContext } from 'react-native-sortables';
import { getTokenValue, styled, ThemeableStack, useTheme } from 'tamagui';

const StyledStack = styled(ThemeableStack, {
  name: 'DraggableItemItemContainer',
  // Can't use pressTheme, hoverTheme etc with animated styles
  padding: '$true',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  borderBottomWidth: 1,
  borderColor: '$borderColor'
});

export const DraggableItemItemContainer = Animated.createAnimatedComponent(StyledStack);

export const useDraggableItemStyle = () => {
  const { isActive, activationAnimationProgress } = useItemContext();

  const { color2, color3 } = useTheme();

  const radius = getTokenValue('$4', 'radius');

  return useAnimatedStyle(() => {
    const borderWidth = isActive.value ? 1 : 0;
    const borderRadius = isActive.value ? radius : 0;
    const elevation = isActive.value ? 5 : 0;
    const transform = [{ rotateZ: withSpring(isActive.value ? '3deg' : '0deg', quicker) }];

    const backgroundColor = interpolateColor(
      activationAnimationProgress.value,
      [0, 1],
      [color2.val, color3.val]
    );

    return {
      backgroundColor,
      borderWidth,
      // TODO: this is needed on web, otherwise the animated style (bbw 0) overrides the styled() values (bbw 1)
      borderBottomWidth: 1,
      borderRadius,
      elevation,
      transform
    };
  });
};
